import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import $ from 'jquery';

class TemplateTypeInput extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.handler = this.handler.bind(this);
  }

  componentDidMount() {
    $(this.refs.select).dropdown();
  }

  handler(evt) {
    this.props.onChange(evt.target.value);
  }

  render() {
    return (
      <select
        name="pattern"
        className="ui dropdown"
        ref="select"
        value={this.props.value || 'text'}
        onChange={this.handler}
      >
        <option value="text">Compact</option>
        <option value="image">Avec images</option>
      </select>
    );
  }
}

export default pure(TemplateTypeInput);



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/questions/TemplateTypeInput.js